import { EmptyView, emptyViewVariants } from '@components'

import { useModal, withModalConditionalRender } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'

import { EnableEInvoicingModal as EnableEInvoicingModalComponent } from '@features/attachments/elements/EnableEInvoicingModal'
import { useIsRegisteredForEInvoicing } from '@features/attachments/hooks/useIsRegisteredForEInvoicing'
import { eInvoicingKycStatusToComponentMapping } from '@features/eInvoicing/constants/eInvoicingKycStatusToComponentMapping'
import { EInvoicingDeactivatedEmptyState } from '@features/eInvoicing/elements/EInvoicingDeactivatedEmptyState'
import { EInvoicingKYCNotAllowed } from '@features/eInvoicing/elements/EInvoicingKYCNotAllowed'
import { useEInvoicingSetup } from '@features/eInvoicing/hooks/useEInvoicingSetup'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { ModalId } from '../../../../../../enums/modalId'
import { TrackingContext } from '../../../../../../enums/trackingContext'

const EnableEInvoicingModal = withModalConditionalRender(EnableEInvoicingModalComponent)

export const EInvoicesEmptyState = (): ReactElement | null => {
  const { open: openEnableEInvoicingModal } = useModal(ModalId.EnableEInvoicingModal)
  const { organization } = useUserOrganization()
  const { isRegistered, isLoading } = useIsRegisteredForEInvoicing()
  const { isEInvoicingEnabled, isUserAuthorizedForKYC, kycStatus, isReactivationInPendingReview } = useEInvoicingSetup()

  const { animation, description, title, buttonText } =
    emptyViewVariants[isRegistered ? 'einvoicesRegistered' : 'einvoicesNotRegistered']

  const handleEInvoicingButtonClick = useCallback(() => {
    openEnableEInvoicingModal()
  }, [openEnableEInvoicingModal])

  if (isLoading) {
    return null
  }
  // NOTE: Remove the null return when enabling e-invoicing for all FR users
  if (organization?.countryId === 'FR') {
    if (!isUserAuthorizedForKYC) {
      return <EInvoicingKYCNotAllowed />
    }

    if (isEInvoicingEnabled) {
      if (isReactivationInPendingReview) {
        return <EInvoicingDeactivatedEmptyState />
      }

      return <>{eInvoicingKycStatusToComponentMapping[kycStatus] ?? null}</>
    }

    return null
  }

  return (
    <>
      <EmptyView
        animationName={animation}
        onClick={handleEInvoicingButtonClick}
        showCTA={!isLoading && !isRegistered}
        tButton={buttonText}
        tDescription={description}
        tTitle={title}
        trackingContext={TrackingContext.EInvoice}
      />
      <EnableEInvoicingModal id={ModalId.EnableEInvoicingModal} />
    </>
  )
}
